export default __webpack_public_path__ + "static/aero_test-7615979300519b0a289461ce20876053.mp4";